import { ReactNode } from "react";
import { cn } from "lib/cn";

export const Table = ({ children, className }: { children: ReactNode; className?: string }) => (
    <div
        className={cn("overflow-auto rounded-2xl border-none bg-[#f6f6f6] shadow-none", className)}
    >
        <table className="w-full border-separate border-spacing-y-3 border-inherit text-left">
            {children}
        </table>
    </div>
);

export const Head = ({ children, className, ...restProps }: React.ComponentProps<"thead">) => (
    <thead
        className={cn(
            "bg-brand-atlantic text-sm font-semibold tracking-wider text-white",
            className,
        )}
        {...restProps}
    >
        {children}
    </thead>
);

export const HeadRow = ({ children, className, ...restProps }: React.ComponentProps<"tr">) => (
    <tr
        className={cn(
            "rounded-lg bg-white shadow-xs",
            "bg-brand-atlantic text-white",
            "transition duration-150 ease-in-out",
            className,
        )}
        {...restProps}
    >
        {children}
    </tr>
);

export const Row = ({ children, className, ...restProps }: React.ComponentProps<"tr">) => (
    <tr
        className={cn(
            "transition duration-150 ease-in-out hover:shadow-md",
            "odd:bg-gray-50 even:bg-white",
            className,
        )}
        {...restProps}
    >
        {children}
    </tr>
);

export const Cell = ({ children, className, ...restProps }: React.ComponentProps<"td">) => (
    <td
        className={cn(
            "px-4 py-2 text-left font-sans text-[14px] leading-[169%] font-normal tracking-normal text-[#424242]",
            "first:rounded-l-md last:rounded-r-md",
            className,
        )}
        {...restProps}
    >
        {children}
    </td>
);

export const IconCell = ({
    children,
    icon,
    ...restProps
}: React.ComponentProps<"td"> & { icon: ReactNode }) => (
    <Cell {...restProps}>
        <div className="flex items-center gap-2">
            {children}
            {icon}
        </div>
    </Cell>
);

export const Body = ({ children, className, ...restProps }: React.ComponentProps<"tbody">) => (
    <tbody className={cn(className)} {...restProps}>
        {children}
    </tbody>
);
